var map = {
	"./basketpositions.json": 1217,
	"./contactperson.json": 1425,
	"./customer.json": 331,
	"./customergeneral.json": 7077,
	"./customervisit.json": 6354,
	"./document.json": 8326,
	"./expensereport.json": 3366,
	"./expensereportposition.json": 2651,
	"./item.json": 1630,
	"./itemstockposition.json": 8767,
	"./lead.json": 8722,
	"./note.json": 8733,
	"./offer.json": 7568,
	"./offerposition.json": 8098,
	"./presales.json": 1874,
	"./process.json": 1400,
	"./project.json": 8118,
	"./quicklinks.json": 7144,
	"./systeminfo.json": 6617,
	"./task.json": 5069,
	"./timerecording.json": 2412,
	"./timerecordingposition.json": 4344,
	"Data/Designer/Defaultviews/basketpositions.json": 1217,
	"Data/Designer/Defaultviews/contactperson.json": 1425,
	"Data/Designer/Defaultviews/customer.json": 331,
	"Data/Designer/Defaultviews/customergeneral.json": 7077,
	"Data/Designer/Defaultviews/customervisit.json": 6354,
	"Data/Designer/Defaultviews/document.json": 8326,
	"Data/Designer/Defaultviews/expensereport.json": 3366,
	"Data/Designer/Defaultviews/expensereportposition.json": 2651,
	"Data/Designer/Defaultviews/item.json": 1630,
	"Data/Designer/Defaultviews/itemstockposition.json": 8767,
	"Data/Designer/Defaultviews/lead.json": 8722,
	"Data/Designer/Defaultviews/note.json": 8733,
	"Data/Designer/Defaultviews/offer.json": 7568,
	"Data/Designer/Defaultviews/offerposition.json": 8098,
	"Data/Designer/Defaultviews/presales.json": 1874,
	"Data/Designer/Defaultviews/process.json": 1400,
	"Data/Designer/Defaultviews/project.json": 8118,
	"Data/Designer/Defaultviews/quicklinks.json": 7144,
	"Data/Designer/Defaultviews/systeminfo.json": 6617,
	"Data/Designer/Defaultviews/task.json": 5069,
	"Data/Designer/Defaultviews/timerecording.json": 2412,
	"Data/Designer/Defaultviews/timerecordingposition.json": 4344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6285;